// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"403":"forum/integrations/tracing","510":"forum/integrations/replay"}[chunkId] + ".js";
};